import React, { Fragment, useCallback } from "react";
import { Row, RowHeader, SaveTable } from "../DataTable.jsx";
import { MRK2_MODULE_DATA, MULTILOOP_MODULE_NAMES, MULTILOOP_OPERATING_MODE_DEVICE, OPERATING_MODE } from "../const.js";
import { ZoneSelector } from "./ZoneSelect.jsx";
import DeviceOptionsEditor from "./loopDeviceSettings/index.jsx";
import { ToggleOption } from "../../bootstrap-micro.js";
import { useHwaddrAndNetworkIdFromRouter, usePanelModuleDeviceFromRouter, usePanelModuleFromRouter, usePanelUpdateAPI } from "../store/panelsSlice.js";
import { useEditorState } from "../utils.js";
import { useSiteConnected } from "../store/connectionSlice.js";
import { useHwaddrFromRouter } from "../store/sitesSlice.js";
import update from "immutability-helper";
import APICall from "../store/apiCall.js";


function getDeviceName(type, port_id, mod_idx)
{
    if( type in MULTILOOP_MODULE_NAMES){
        return `${MULTILOOP_MODULE_NAMES[type]} (Port: ${port_id}.${mod_idx+1})`;
    }
    
    const mk2Entry = MRK2_MODULE_DATA.find(d => d.id == type);

    if(mk2Entry != undefined){
        return `${mk2Entry.name} (${mk2Entry.modelNumber})`;
    }

    return `[UNKNOWN DEVICE][${type}]`
}    


export const ModuleDeviceEditor = () => {

    const isConnected = useHwaddrFromRouter(useSiteConnected);
    const panelModule = usePanelModuleFromRouter();
    const device = usePanelModuleDeviceFromRouter();

    const { updateDeviceName, updateDeviceZone } = usePanelUpdateAPI();
    const [value, isDirty, updateValue, resetDirty ] = useEditorState(device);

    const saveToPanel = useCallback(async () => {

        await Promise.all([
            updateDeviceName(
                panelModule.port_id, 
                value.mod_idx,
                value.name
            ),
            updateDeviceZone(
                panelModule.port_id,
                value.mod_idx,
                value.zone
            )
        ]);
        resetDirty();
    }, [value, panelModule]);

    if(!panelModule){
        return <p>Loading module data...</p>
    }

    if(!value){
        return <p>Loading module device data...</p>
    }

    let additionalOptions = null;
    if (panelModule.port_type == "MOD_MRKII") {
        additionalOptions = (
            <Fragment>
                <Row label="Address">{value.settings.address}</Row>
                <Row label="Mode">
                    <select disabled={!isConnected || true} className="form-control" value={value.settings.mode} onChange={ ev => updateValue(update(value, { settings: { mode: { $set: ev.target.value } } })) }>
                        {Object.keys(OPERATING_MODE).filter(k => (
                            k != "MODE_NONE" &&
                                (
                                    MRK2_MODULE_DATA.find(d => d.id == value.type).modes == null ||
                                    MRK2_MODULE_DATA.find(d => d.id == value.type).modes.indexOf(k) != -1
                                )
                        )
                        ).map(k => <option key={k} value={k}>{OPERATING_MODE[k]}</option>)}
                    </select>
                </Row>
                <DeviceOptionsEditor
                    disabled={!isConnected || true}
                    deviceType={value.type}
                    value={value.settings.deviceOptions}
                    onChange={(d) => updateValue(update(value, { settings: { deviceOptions: { $set: d } } }))}
                />
            </Fragment>
        );
    }
    if(panelModule.port_type.startsWith("MOD_ZMU_CLASS")){
        additionalOptions = <Fragment>
            <Row label="Mode">
                <select disabled={!isConnected || true} className="form-control" value={value.settings.mode} onChange={ ev => updateValue(update(value, { settings: { mode: { $set: ev.target.value } } })) }>
                    {MULTILOOP_OPERATING_MODE_DEVICE.filter(k => (k != "MODE_NONE")).map(k => <option key={k} value={k}>{OPERATING_MODE[k]}</option>)}
                </select>
            </Row>
            <Row label="Input Type">{value.settings.inputType}</Row>
        </Fragment>
    }
    if(panelModule.port_type.startsWith("MOD_NAC_CLASS")){
        additionalOptions = <Fragment>
            <Row label="Mode">
                <select disabled={!isConnected || true} className="form-control" value={value.settings.mode} onChange={ ev => updateValue(update(value, { settings: { mode: { $set: ev.target.value } } })) }>
                    {MULTILOOP_OPERATING_MODE_DEVICE.filter(k => (k != "MODE_NONE")).map(k => <option key={k} value={k}>{OPERATING_MODE[k]}</option>)}
                </select>
            </Row>
            <Row label="Reset Time"><input disabled={!isConnected || true} className="form-control" type="number" min="0" step="1" value={value.settings.resetTime} /></Row>
            <Row label="Sounder Type">{value.settings.sounderType}</Row>
        </Fragment>
    }

    if(panelModule.port_type == "SMARTLOOP_LOCAL"){
        additionalOptions = <Fragment>
            <Row label="Is Normally Closed">
                <ToggleOption disabled={!isConnected || true} value={value.settings.isNormallyClosed} />
            </Row>
            <Row label="Relay Type">{value.settings.relayType}</Row>
        </Fragment>
    }

    if(panelModule.port_type == "SMARTLOOP_LOCAL"){
        additionalOptions = (<Row label="Mode">
            <select 
                className="form-control" 
                disabled={!isConnected || true} 
                value={value.settings.mode}
                onChange={ev => updateValue( update(value, { settings: { mode: { $set: ev.target.value } } }))}
            >
                <option value="MODE_ENABLED">Enabled</option>
                <option value="MODE_BOTH_DISABLED">Disabled</option>
            </select>
        </Row>);
    }

        


    {return <Fragment>
        <div className="row">
            <SaveTable disabled={!(isConnected || isDirty)} onSave={saveToPanel}>
                <RowHeader label="General" />
                <Row label="Type">{getDeviceName(value.type, panelModule.port_id, value.mod_idx)}</Row>
                <Row label="Name"><input disabled={!isConnected} className="form-control" value={value.name} type="text" maxLength={47} onChange={ev => updateValue(update(device, { name: { $set: ev.target.value } }))} /></Row>
                <Row label="Zone"><ZoneSelector disabled={!isConnected} value={value.zone} onChange={ev => updateValue(update(device, { zone: { $set: parseInt(ev.target.value) } }))} /></Row>

                {
                    (panelModule.port_type == "MOD_MRKII")
                        ?
                        <Row label="Address">{value.settings.address}</Row>
                        : null
                }
                { /*
                <RowHeader label="Settings"/>
                                                
                        
                {additionalOptions}

                */ }

            </SaveTable>
        </div>
        {/* <pre>{JSON.stringify(value, null, 2)}</pre> */}
    </Fragment>;}
}

